import { toast } from 'react-toastify'
import './toastStyles.css'
import CustomMessage from './CustomMessage'

const showSuccessToast = (message, position = 'top-right') => {
  toast.success(<CustomMessage message={message} variant="success" />, {
    position,
    autoClose: 1400,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    icon: false,
    closeButton: false,
    className: 'custom-success-toast',
  })
}

const showErrorToast = (message, duration = 1400, position = 'top-right') => {
  toast.error(<CustomMessage message={message} variant="error" />, {
    position,
    autoClose: duration,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    icon: false,
    closeButton: false,
    className: 'custom-error-toast', // Add custom class for error
  })
}

const showWarningToast = (message, duration = 60000, position = 'top-right') => {
  toast.warn(<CustomMessage message={message} variant="warning" />, {
    position,
    autoClose: duration,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    icon: false,
    closeButton: false,
    className: 'custom-warning-toast',
  })
}

export { showErrorToast, showSuccessToast, showWarningToast }
